// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
    direction: ltr;
}

.pagination .page-item .page-link {
    border-radius: 8px !important;
    margin: 4px;
    width: 32px;
    text-decoration: none;
    height: 32px;
    white-space: nowrap;
}

.page-link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.25;
    color: #fffad9;
    background-color: transparent;
    border: 2px solid #c3c5b780;
    margin-top: -2px;
}

.page-link:hover {
    z-index: 2;
    color: black !important;
    text-decoration: none;
    background-color: #ffc800;
    border: 2px solid #ffc800;
}

.page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 0rem rgba(93, 120, 255, 0.25);
}

.page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.page-item.active .page-link {
    z-index: 3;
    color: white;
    text-decoration: none;
    border: 2px solid #ffc800;
}

.page-item.disabled .page-link {
    color: #fffad9;
    cursor: not-allowed;
    text-decoration: none;
    font-size: 1.3rem;
    background-color: transparent;
    border: 2px solid #c3c5b770;
}

.pagination-lg .page-link {
    font-size: 1.3rem;
    line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.76563rem;
    line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}


/* dark */

.pagination .d-page-item .d-page-link {
    border-radius: 8px !important;
    margin: 4px;
    width: 32px;
    text-decoration: none;
    height: 32px;
    white-space: nowrap;
}

.d-page-link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.25;
    color: #191c20;
    background-color: transparent;
    border: 2px solid #c3c5b780;
    margin-top: -2px;
}

.d-page-link:hover {
    z-index: 2;
    color: black !important;
    text-decoration: none;
    background-color: #ffc800;
    border: 2px solid #ffc800;
}

.d-page-link:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 0rem rgba(93, 120, 255, 0.25);
}

.d-page-item:first-child .d-page-link {
    margin-left: 0;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.d-page-item:last-child .d-page-link {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.d-page-item.active .d-page-link {
    z-index: 3;
    color: black;
    text-decoration: none;
    border: 2px solid #ffc800;
}

.d-page-item.disabled .d-page-link {
    color: #191c20;
    cursor: not-allowed;
    text-decoration: none;
    font-size: 1.3rem;
    background-color: transparent;
    border: 2px solid #c3c5b770;
}

.pagination-lg .d-page-link {
    font-size: 1.3rem;
    line-height: 1.5;
}

.pagination-lg .d-page-item:first-child .d-page-link {
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
}

.pagination-lg .d-page-item:last-child .d-page-link {
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.pagination-sm .d-page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.76563rem;
    line-height: 1.5;
}

.pagination-sm .d-page-item:first-child .d-page-link {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}

.pagination-sm .d-page-item:last-child .d-page-link {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;;AAGA,SAAS;;AAET;IACI,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC","sourcesContent":[".pagination {\n    display: flex;\n    padding-left: 0;\n    list-style: none;\n    border-radius: 0.25rem;\n    direction: ltr;\n}\n\n.pagination .page-item .page-link {\n    border-radius: 8px !important;\n    margin: 4px;\n    width: 32px;\n    text-decoration: none;\n    height: 32px;\n    white-space: nowrap;\n}\n\n.page-link {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1.25;\n    color: #fffad9;\n    background-color: transparent;\n    border: 2px solid #c3c5b780;\n    margin-top: -2px;\n}\n\n.page-link:hover {\n    z-index: 2;\n    color: black !important;\n    text-decoration: none;\n    background-color: #ffc800;\n    border: 2px solid #ffc800;\n}\n\n.page-link:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: 0 0 0 0rem rgba(93, 120, 255, 0.25);\n}\n\n.page-item:first-child .page-link {\n    margin-left: 0;\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n}\n\n.page-item.active .page-link {\n    z-index: 3;\n    color: white;\n    text-decoration: none;\n    border: 2px solid #ffc800;\n}\n\n.page-item.disabled .page-link {\n    color: #fffad9;\n    cursor: not-allowed;\n    text-decoration: none;\n    font-size: 1.3rem;\n    background-color: transparent;\n    border: 2px solid #c3c5b770;\n}\n\n.pagination-lg .page-link {\n    font-size: 1.3rem;\n    line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n    border-top-left-radius: 0.3rem;\n    border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n    border-top-right-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.76563rem;\n    line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n    border-top-left-radius: 0.2rem;\n    border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n    border-top-right-radius: 0.2rem;\n    border-bottom-right-radius: 0.2rem;\n}\n\n\n/* dark */\n\n.pagination .d-page-item .d-page-link {\n    border-radius: 8px !important;\n    margin: 4px;\n    width: 32px;\n    text-decoration: none;\n    height: 32px;\n    white-space: nowrap;\n}\n\n.d-page-link {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1.25;\n    color: #191c20;\n    background-color: transparent;\n    border: 2px solid #c3c5b780;\n    margin-top: -2px;\n}\n\n.d-page-link:hover {\n    z-index: 2;\n    color: black !important;\n    text-decoration: none;\n    background-color: #ffc800;\n    border: 2px solid #ffc800;\n}\n\n.d-page-link:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: 0 0 0 0rem rgba(93, 120, 255, 0.25);\n}\n\n.d-page-item:first-child .d-page-link {\n    margin-left: 0;\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.d-page-item:last-child .d-page-link {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n}\n\n.d-page-item.active .d-page-link {\n    z-index: 3;\n    color: black;\n    text-decoration: none;\n    border: 2px solid #ffc800;\n}\n\n.d-page-item.disabled .d-page-link {\n    color: #191c20;\n    cursor: not-allowed;\n    text-decoration: none;\n    font-size: 1.3rem;\n    background-color: transparent;\n    border: 2px solid #c3c5b770;\n}\n\n.pagination-lg .d-page-link {\n    font-size: 1.3rem;\n    line-height: 1.5;\n}\n\n.pagination-lg .d-page-item:first-child .d-page-link {\n    border-top-left-radius: 0.3rem;\n    border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .d-page-item:last-child .d-page-link {\n    border-top-right-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .d-page-link {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.76563rem;\n    line-height: 1.5;\n}\n\n.pagination-sm .d-page-item:first-child .d-page-link {\n    border-top-left-radius: 0.2rem;\n    border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .d-page-item:last-child .d-page-link {\n    border-top-right-radius: 0.2rem;\n    border-bottom-right-radius: 0.2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
